import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SelfDevelopmentOverview from './SelfDevelopmentOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanySelfDevelopmentOverview } from './companySelfDevelopmentApi';

/** Company Self Development → Overview, scoped to this company. */
const CSelfDevelopmentOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanySelfDevelopmentOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Self Development | Shoorah</title>
      </Helmet>
      <SelfDevelopmentOverview
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CSelfDevelopmentOverview;
